module.exports = __webpack_public_path__ + "media/images/icons/self-storage-small-5x10-icon-34270053683eaa7ecb97a8f7ccdb8760.png";